const n = (e) => e, t = (e) => e, i = (e) => "events" in e && typeof e.events == "object", o = (e) => "getProfileMenuItems" in e && typeof e.getProfileMenuItems == "function", s = (e) => "getRoutes" in e && typeof e.getRoutes == "function", c = (e) => "renderSearch" in e && typeof e.renderSearch == "function", u = (e) => "initialize" in e && typeof e.initialize == "function", f = (e) => "getHead" in e && typeof e.getHead == "function", g = (e) => "getMdxComponents" in e && typeof e.getMdxComponents == "function", r = (e) => "getIdentities" in e && typeof e.getIdentities == "function";
export {
  n as createApiIdentityPlugin,
  t as createProfileMenuPlugin,
  f as hasHead,
  r as isApiIdentityPlugin,
  i as isEventConsumerPlugin,
  g as isMdxProviderPlugin,
  s as isNavigationPlugin,
  o as isProfileMenuPlugin,
  c as isSearchPlugin,
  u as needsInitialization
};
//# sourceMappingURL=zudoku.plugins.js.map
